import { createContext, useContext } from "react"
import { useConsole } from "contexts/Console"
import { motionValue } from "framer-motion"

const defaultContextValue = {
  defaultTitle: undefined,
  motion: motionValue(0),
  rtitle: undefined,
  verticalIfDesktop: false,
}

const Context = createContext(defaultContextValue)

const useController = () => {
  return useContext(Context)
}

const Controller = ({ children, ...props }) => {
  const console = useConsole()
  const ctx = Object.assign({}, defaultContextValue, props)

  console.verbose("Nav:Bento:Controller(%o)", ctx)
  return <Context.Provider value={ctx}>{children}</Context.Provider>
}

export default Controller
export { useController }
